import React, { Component } from 'react'
import Loading from './Loading'
import { Container, Card, Form, Button } from 'react-bootstrap'
import web3 from '../ethereum/web3'
import Header from './Header'
import tokenSale from '../ethereum/tokenSale'

class BuyToken extends Component {
    constructor(props) {
        super(props)

        this.state = {
            price: '',
            tokenContract: '',
            tokensSold: '',
            numberOfTokens: '',
            ethers: '',
            loading: false
        }
    }

    async componentDidMount() {
        const { params } = this.props.match
        const tSale = tokenSale(params.id)

        const priceWei = await tSale.methods.price().call()
        const tokenContract = await tSale.methods.tokenContract().call()
        const tokensSold = await tSale.methods.tokensSold().call()

        const price = web3.utils.fromWei(priceWei, 'ether')

        this.setState({
            price,
            tokenContract,
            tokensSold
        })
    }

    onSubmit = async (event) => {
        event.preventDefault();

        this.setState({ loading: true });

        try {
            const accounts = await web3.eth.getAccounts();
            const { params } = this.props.match
            const tSale = tokenSale(params.id)
            await tSale.methods
                .buyTokens(this.state.numberOfTokens)
                .send({
                    from: accounts[0],
                    value: web3.utils.toWei(this.state.ethers, 'ether')
                })

        } catch (err) {
            window.alert(err.message)
        }

        this.setState({ loading: false });

    }

    render() {
        return (
            <Container >
                <Header />
                <div style={{ marginTop: '25px' }}>
                    <Card border="success" className="text-center">
                        <Card.Header>

                            <h6>Token Contract: {this.state.tokenContract}</h6>
                            <h6> Price: {this.state.price} ether per token</h6>
                            <h6>Tokens Sold: {this.state.tokensSold}</h6>

                        </Card.Header>

                        <Card.Body>
                            <Form onSubmit={this.onSubmit}>
                                <Form.Group>
                                    <Form.Label>Amount of Tokens</Form.Label>
                                    <Form.Control
                                        onChange={event => this.setState({ numberOfTokens: event.target.value })}
                                        placeholder="1000"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Ethers</Form.Label>
                                    <Form.Control
                                        onChange={event => this.setState({ ethers: event.target.value })}
                                        placeholder="ethers to buy tokens"
                                        required
                                    />
                                </Form.Group>
                                <Button
                                    variant="success"
                                    type="submit"
                                >
                                    Buy Token!
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div style={{ float: 'right' }}>
                        {this.state.loading ? <Loading /> : ''}
                    </div>
                </div>
            </Container>
        )
    }
}

export default BuyToken;
